import BigNumber from './layout/bigNumber';
import Fact from './layout/fact';
import React from 'react';
import styled from 'styled-components';

const Grid = styled.div`
  display: grid;
  gap: 20px;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  margin: 20px;

  @media(max-width: 1100px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media(max-width: 720px) {
    grid-template-columns: 1fr;
    margin: 20px 0;
  }
`;

const KpiFact = styled(Fact)`
  margin: 0;
`;

const RankingFact = styled(Fact)`
  grid-column: 1 / -1;
  margin: 0;
`;

const Ranking = styled.div`
  display: grid;
  gap: 14px;
  grid-template-columns: repeat(3, minmax(0, 1fr));

  @media(max-width: 900px) {
    grid-template-columns: 1fr;
  }
`;

const RankingItem = styled.div`
  border-left: 3px solid var(--primary-color);
  padding-left: 14px;

  h5 {
    color: #7b91b1;
    font-size: 13px;
    line-height: 1.35;
    margin: 0 0 8px;
  }

  strong {
    color: var(--primary-color);
    display: block;
    font-family: 'Montserrat', sans-serif;
    font-size: 26px;
    font-weight: 900;
    line-height: 1.1;
  }

  span {
    color: var(--dark-blue-color);
    display: block;
    font-size: 13px;
    margin-top: 4px;
  }
`;

const formatNumber = value => Number(value || 0).toLocaleString('es-ES', {
  maximumFractionDigits: 0,
  minimumFractionDigits: 0,
});

const formatPercent = value => Number(value || 0).toLocaleString('es-ES', {
  maximumFractionDigits: 0,
  minimumFractionDigits: 0,
});

const ElectricDemand = ({ kpiDict }) => {
  const targetYear = kpiDict.demanda_electrica_target_year;
  const baseYear = kpiDict.demanda_electrica_base_year;
  const increment = kpiDict.demanda_electrica_increment_gwh;
  const percent = kpiDict.demanda_electrica_increment_percent;
  const baseScenarioDifference = kpiDict.demanda_electrica_base_scenario_difference;
  const baseScenarioPercentDifference = kpiDict.demanda_electrica_base_scenario_percent_difference;
  const topSectors = kpiDict.demanda_electrica_top_sectores || [];

  return (
    <Grid>
      <KpiFact>
        <h4>
          Incremento de demanda eléctrica en {targetYear} respecto de {baseYear}
        </h4>
        <BigNumber>
          <h1>
            {formatNumber(increment)}
          </h1>
          <label>
            GWh
          </label>
        </BigNumber>
      </KpiFact>
      <KpiFact>
        <h4>
          Incremento porcentual de demanda eléctrica en {targetYear} respecto de {baseYear}
        </h4>
        <BigNumber>
          <h1>
            {formatNumber(percent)}
          </h1>
          <label>
            %
          </label>
        </BigNumber>
      </KpiFact>
      <KpiFact>
        <h4>
          Diferencia de demanda eléctrica con respecto a Escenario Base para el año {targetYear}
        </h4>
        <BigNumber>
          <h1>
            {formatNumber(baseScenarioDifference)}
          </h1>
          <label>
            GWh
          </label>
        </BigNumber>
      </KpiFact>
      <KpiFact>
        <h4>
          Diferencia porcentual de demanda eléctrica con respecto a Escenario Base para el año {targetYear}
        </h4>
        <BigNumber>
          <h1>
            {formatNumber(baseScenarioPercentDifference)}
          </h1>
          <label>
            %
          </label>
        </BigNumber>
      </KpiFact>
      <RankingFact>
        <h4>
          Sectores con mayor demanda eléctrica en {targetYear}
        </h4>
        <Ranking>
          {topSectors.map((sector, index) => (
            <RankingItem key={sector.label}>
              <h5>{index + 1}. {sector.label}</h5>
              <strong>{formatNumber(sector.value)} GWh</strong>
              <span>{formatPercent(sector.share)}% del total</span>
            </RankingItem>
          ))}
        </Ranking>
      </RankingFact>
    </Grid>
  );
};

export default ElectricDemand;
